import { Helmet } from "react-helmet-async";

export default function NoIndex() {
  return (
    <Helmet>
      <meta name="robots" content="noindex,follow" />
    </Helmet>
  );
}
